module.exports = __webpack_public_path__ + "static/IBM_logoRR_blue60_RGB-f09b4201d1c80e315c05829ed06a98e0.gif";